import React, { useEffect, useState } from 'react'
import * as S from './styled'
import {
  ActionButtonCard,
  ActionButtonCardCancel,
  CardContainer
} from '../../styles'
import { getByIdSession } from '../../../../../main/usecases/services/session'
import { useModalBox, useOnChangeDetect } from '../../../../contexts'
import { SessionModel } from '../../../../../domain/models/session'
import moment from 'moment'
import 'moment/locale/pt-br'
import {
  IconEditSvg,
  IconTrashSvg
} from '../../../../assets/icons/svgComponents'
import SessionForm, {
  PaymetMethods
} from '../../../../components/timeline/modal/session'
import DeleteSessionModal from '../../../../components/accordion-table/delete-session'
import { SubHeader } from '../../../../components'

type PageProps = {
  match: any
}

const InternalSession = ({ match }: PageProps) => {
  const { refresh } = useOnChangeDetect()
  const [data, setData] = useState<SessionModel>()
  const { modalBox } = useModalBox()
  moment.locale('pt-br')
  useEffect(() => {
    ;(async () => {
      if (match.params.idsessao) {
        const res = await getByIdSession(match.params.idsessao).load()
        setData(res)
        console.log(data)
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, match.params.idsessao])
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleOpenDeleteServiceModal = () => {
    modalBox(<DeleteSessionModal item={data} />, 'Deletar Sessão', '35%')
  }

  const handleOpenSessionModal = () => {
    if (data) {
      modalBox(
        <SessionForm
          cdServiceProps={Number(match?.params.idservico)}
          session={data}
        />,
        'Validação de dados',
        '46%'
      )
    }
  }

  return (
    <S.Wrapper>
      <SubHeader
        page="Prontuário"
        link={`/meus-pacientes/${match.params.id}/prontuario?serviceId=${match.params.idservico}`}
      />
      {data && (
        <CardContainer>
          <S.TitleInternal>Sessão</S.TitleInternal>
          <S.Card>
            <S.HeaderCard>
              <S.TitleHeaderCard>{data.titulo}</S.TitleHeaderCard>
              <S.SubtitleHeaderCard>
                {moment(data.dataInicio).format('DD [de] MMMM [de] YYYY')} |{' '}
                {moment(data.dataInicio?.replace('.000+00:00', '')).format(
                  'HH:mm[h]'
                )}{' '}
                -{' '}
                {moment(data.dataFim?.replace('.000+00:00', '')).format(
                  'HH:mm[h]'
                )}
                <S.ActionsCard>
                  <span>
                    <ActionButtonCard
                      disabled={!data}
                      onClick={() => handleOpenSessionModal()}
                    >
                      <IconEditSvg />
                    </ActionButtonCard>
                    <div className="ml">
                      <ActionButtonCardCancel
                        disabled={!data}
                        onClick={() => handleOpenDeleteServiceModal()}
                      >
                        <IconTrashSvg />
                      </ActionButtonCardCancel>
                    </div>
                  </span>
                </S.ActionsCard>
              </S.SubtitleHeaderCard>
            </S.HeaderCard>
            <S.ContentCard>{data.resumo}</S.ContentCard>
            <S.TitleHeaderCard>Pagamento</S.TitleHeaderCard>
            <S.PaymentRow>
              <S.BoxItemValue>
                <S.LabelStyled>Valor</S.LabelStyled>
                <S.ValueStyled>
                  {data.valor.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL'
                  })}
                </S.ValueStyled>
              </S.BoxItemValue>
              <S.BoxItemValue>
                <S.LabelStyled>Forma de Pagamento</S.LabelStyled>
                <S.ValueStyled>
                  {
                    PaymetMethods.find((el) => el.value === data.formaPgto)
                      ?.label
                  }
                </S.ValueStyled>
              </S.BoxItemValue>
              <S.BoxItemValue>
                <S.LabelStyled>Status</S.LabelStyled>
                <S.ValueStyled>{data.pago ? 'Pago' : 'Pendente'}</S.ValueStyled>
              </S.BoxItemValue>
            </S.PaymentRow>
          </S.Card>
        </CardContainer>
      )}
    </S.Wrapper>
  )
}

export default InternalSession
